import GQDatePicker from "components/GQNavbar/GQDatePicker";
import GQDateRangePicker from "components/GQNavbar/GQDateRangePicker";
import {
    DATE_PICKER_DEFAULT_PRESETS,
    MOMENTJS_DATE_DISPLAY_FORMAT,
    E_TIME_PRESET_KEYS,
    SIGNALS_DATE_PICKER_DEFAULT_PRESETS,
    DATE_FNS_DATE_DISPLAY_FORMAT,
} from '../../constants';
import { VIEW } from "interfaces";
import moment from "moment";
import DatePicker from "react-datepicker";
import PickerToggler from "./PickerToggler";
import rootStore, { IMobxRootState } from 'RootStore';
import cx from 'classnames';
import { inject } from 'mobx-react';

type Props = {
    minDate?: moment.Moment;
    maxDate?: moment.Moment;
    currentView: VIEW;
    virtualToday?: moment.Moment;
    heatmapStartDate?: Date;
    heatmapTimeSpan?: E_TIME_PRESET_KEYS;
}
export const DatePickerContainer = inject(
    ({ chartStore, heatmapStore }: IMobxRootState) => {
        return {
            minDate: chartStore?.baseDate
                ?.clone()
                ?.startOf('day')
                ?.subtract(chartStore?.rangeLeft, 'days'),
            maxDate: chartStore?.baseDate
                ?.clone()
                ?.startOf('day')
                ?.add(chartStore?.rangeRight, 'days'),
            virtualToday: chartStore.virtualToday,
            heatmapStartDate: heatmapStore.startDate,
            heatmapTimeSpan: heatmapStore.timeSpan,
        };
    }
    )((props: Props) => {
    const {
        currentView,
        minDate,
        maxDate,
        virtualToday,
        heatmapStartDate,
        heatmapTimeSpan,
    } = props;
        switch (currentView) {
            case VIEW.WORLD_GRAPH:
            case VIEW.SORT_BY_DELTA:
            case VIEW.SORT_BY_CONTINGENT_DELTA:
            case VIEW.SORT_BY_DELTA:
            case VIEW.CONTINGENT:
            case VIEW.CONTINGENT_GRAPH:
                return (
                    <GQDateRangePicker
                        initialStartDate={minDate.toDate()}
                        initialEndDate={maxDate.toDate()}
                        onChange={rootStore.chartStore.setNewRangeByDates}
                        allowPresetSelectionOutOfRange={true}
                        presets={DATE_PICKER_DEFAULT_PRESETS}
                        placement="top"
                    />
                );
            case VIEW.HEATMAP:
                return (
                    <PickerToggler
                        label={moment(heatmapStartDate).format(
                            MOMENTJS_DATE_DISPLAY_FORMAT
                        )}
                        icon="Calendar">
                        <GQDatePicker
                            placement="top"
                            onChangeStartDate={(date: Date) => {
                                rootStore.heatmapStore.setStartDate(date);
                            }}
                            onChangeTimeSpan={(
                                timeSpan: E_TIME_PRESET_KEYS
                            ) => {
                                rootStore.heatmapStore.setTimeSpan(timeSpan);
                            }}
                            startDate={heatmapStartDate}
                            timespanPresets={
                                SIGNALS_DATE_PICKER_DEFAULT_PRESETS
                            }
                            timespan={heatmapTimeSpan}
                        />
                    </PickerToggler>
                );
            case VIEW.SORT_BY_RISK:
            case VIEW.SORT_BY_CONTINGENT_RISK:
                return (
                    <PickerToggler
                        label={virtualToday.format(
                            MOMENTJS_DATE_DISPLAY_FORMAT
                        )}
                        icon="Calendar">
                        <div style={{ position: 'relative' }}>
                            <div
                                className={cx(
                                    'date-range-picker-wrapper',
                                    'top'
                                )}>
                                <DatePicker
                                    inline
                                    showPopperArrow={false}
                                    calendarClassName="datepicker-single"
                                    onChange={(date: Date) => {
                                        rootStore.chartStore.setVirtualToday(
                                            moment(date)
                                        );
                                    }}
                                    selected={virtualToday.toDate()}
                                    minDate={new Date(2013, 1, 1)}
                                    maxDate={
                                        new Date(
                                            new Date().getFullYear() + 2,
                                            new Date().getMonth(),
                                            new Date().getDay()
                                        )
                                    }
                                    dateFormat={DATE_FNS_DATE_DISPLAY_FORMAT}
                                    showMonthDropdown
                                    showYearDropdown
                                    peekNextMonth={false}
                                />
                            </div>
                        </div>
                    </PickerToggler>
                );
        }
    }
);


export default DatePickerContainer;